export function mapUserStateToProps(state, props) {
    return {
        ...state,
        user: state.user,
    };
}
